module.exports = __webpack_public_path__ + "images/category_lp/brand/new/assessment_achievements/3@2x_4d6eaa2aa4be57053f85b21a4a08c7d2.png";